/**
 * @author Charles Blais
 */
import { useState, useRef, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Button } from 'react-bootstrap';

import useStationsInfo from '../hooks/use-stations-info';

import TraceLivePlot from '../components/plots/trace-live-plot';

import { useAppState } from '../contexts/app-state-provider';

import { useLanguageState } from '../contexts/language-state-provider';


const ContainerPlots = () => {
  const { sncl } = useParams();
  const [ state ] = useAppState();
  const [ lang ] = useLanguageState();
  const [ play, setPlay ] = useState(true);
  const [ diplayName, setDisplayName ] = useState(sncl);
  const refPlot = useRef<HTMLHeadingElement>(null);

  const { stations } = useStationsInfo({initialUrl: state.url})

  useEffect(() => {
    refPlot.current?.focus()
  }, [sncl]);

  // if we have loaded stations, find the name instead for display
  useEffect(() => {
    if(stations && sncl && stations[sncl]) {
      setDisplayName(`${stations[sncl].name} (${sncl})`);
    } else {
      setDisplayName(sncl);
    }
  }, [stations, sncl, setDisplayName]);

  if (!sncl)
    return null;

  return (
    <div className='viewer-display'>
      <h2 ref={refPlot} tabIndex={-1}>{diplayName}</h2>
      <h3>{lang.plot.title1m}</h3>
      <TraceLivePlot
        sncl={sncl}
        period='1m'
        fetchInterval={play?60:undefined}
        dataPeriod={60}
        dataDelay={60*3}
        updateInterval={play?1:undefined}
        xtitle={ lang.plot.label }
      />
      <h3>{lang.plot.title10m}</h3>
      <TraceLivePlot
        sncl={sncl}
        period='10m'
        fetchInterval={play?60:undefined}
        dataPeriod={60*10}
        dataDelay={60*3}
        updateInterval={play?10:undefined}
        xtitle={ lang.plot.label }
      />
      <h3>{lang.plot.title1h}</h3>
      <TraceLivePlot
        sncl={sncl}
        period='1h'
        fetchInterval={play?60:undefined}
        dataPeriod={60*60}
        dataDelay={60*3}
        updateInterval={play?30:undefined}
        xtitle={ lang.plot.label }
      />
      <div className='viewer-button'>
      { play ?
        <Button bsSize="large" bsStyle="danger" onClick={() => setPlay(false)}>{lang.pause}</Button>
        : <Button bsSize="large" bsStyle="success" onClick={() => setPlay(true)}>{lang.play}</Button>
      }
      </div>
    </div>
  )
}

export default ContainerPlots;
